import React, { useEffect, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useAppSelector, useAppDispatch } from '../../helpers/hooks';
import { setSidebarOpen } from '../../slices/layout/layoutSlice';

const Layout: React.FC = () => {
  const dispatch = useAppDispatch();
  const { layoutMode, sidebarOpen } = useAppSelector((state) => state.layout);

  // Handle window resize
  const handleResize = useCallback(() => {
    const windowWidth = window.innerWidth;
    if (windowWidth < 992) {
      // Mobile: always collapsed by default
      document.documentElement.setAttribute('data-sidebar-size', 'lg');
    } else {
      // Desktop: respect user preference
      document.documentElement.setAttribute('data-sidebar-size', sidebarOpen ? 'lg' : 'sm');
    }
  }, [sidebarOpen]);

  useEffect(() => {
    // Set layout attributes
    document.documentElement.setAttribute('data-layout', 'vertical');
    document.documentElement.setAttribute('data-layout-mode', layoutMode);
    document.documentElement.setAttribute('data-sidebar', 'dark');
    document.documentElement.setAttribute('data-sidebar-size', sidebarOpen ? 'lg' : 'sm');

    // Add resize listener
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [layoutMode, sidebarOpen, handleResize]);

  // Handle overlay click (mobile)
  const handleOverlayClick = () => {
    document.body.classList.remove('vertical-sidebar-enable');
    dispatch(setSidebarOpen(false));
  };

  return (
    <div id="layout-wrapper">
      <Header />
      <Sidebar />
      <div className="vertical-overlay" onClick={handleOverlayClick}></div>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
